import { render, staticRenderFns } from "./PagamentoInserir.vue?vue&type=template&id=604eb1d8&"
import script from "./PagamentoInserir.vue?vue&type=script&lang=js&"
export * from "./PagamentoInserir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports